import React from 'react';
import { FeatureWrapper, FeatureContainer, FeatureCards, Card, CardHead, CardContent } from './style';
import { MdOutlineColorLens } from 'react-icons/md';
import { GoHistory } from 'react-icons/go';
import { GiNewShoot, GiMultipleTargets } from 'react-icons/gi';
import { SiPlaycanvas } from 'react-icons/si';
import { LuScaling } from 'react-icons/lu';
import { ImMakeGroup } from 'react-icons/im';
import { FiLayers } from'react-icons/fi';

const featureData = [
  {
    title: "History",
    desc: "Keep track of everything you've created",
    icon: <GoHistory />
  },
  {
    title: "New Models",
    desc: "Keep track of everything you've created",
    icon: <GiNewShoot />
  },
  {
    title: "Multi-generations",
    desc: "Keep track of everything you've created",
    icon: <GiMultipleTargets />
  },
  {
    title: "Styles",
    desc: "Keep track of everything you've created",
    icon: <MdOutlineColorLens />
  },
  {
    title: "Canvas",
    desc: "Keep track of everything you've created",
    icon: <SiPlaycanvas />
  },
  {
    title: "Upscalling",
    desc: "Keep track of everything you've created",
    icon: <LuScaling />
  },
  {
    title: "Making",
    desc: "Keep track of everything you've created",
    icon: <ImMakeGroup />
  },
  {
    title: "Layers",
    desc: "Keep track of everything you've created",
    icon: <FiLayers />
  },
]

const Feature = () => {
  return (
    <FeatureWrapper>
      <FeatureContainer>
        <h1 data-aos="fade-down" data-aos-delay="1200">Features</h1>
        <FeatureCards data-aos="fade-up" data-aos-delay="1500">
          {
            featureData.map((i, k) => (
              <Card >
                <CardHead>
                  {i.icon}
                  <h4>{i.title}</h4>
                </CardHead>
                <CardContent>
                  <span>{i.desc}</span>
                </CardContent>
              </Card>
            ))
          }
        </FeatureCards>
      </FeatureContainer>
    </FeatureWrapper>
  )
}

export default Feature